import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  BottomNavigation,
  BottomNavigationAction,
  Drawer,
  Hidden,
} from "@material-ui/core";
import Close from "@material-ui/icons/Close";
import SideBar from "Components/Navigators/SideBar";
import MenuIcon from "@material-ui/icons/Menu";
import "./BottomNavigator.css";
import { BOTTOM_NAVIGATOR_MENU } from "./list";
const ACTIVE = "#b2006f";
const INACTIVE = "#542785";

const BottomNavigator = () => {
  const [active, setActive] = useState(1);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const onClick = (idx) => () => {
    setActive(idx);
  };

  const onMenuClick = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const onMenuClose = () => {
    setIsMenuOpen(false);
  };
  return (
    <Hidden mdUp>
      <BottomNavigation
        value={active}
        showLabels
        className="body"
        style={{
          "& .MuiBottomNavigationAction-root": {
            color: "red", // Inactive color
          },
          "& .Mui-selected": {
            color: "primary.main", // Active color
          },
        }}
      >
        <Drawer
          anchor="right"
          open={isMenuOpen}
          onClose={onMenuClose}
          variant="temporary"
          classes={{ paper: "drawerPaper" }}
        >
          <SideBar onItemClick={onMenuClose} />
        </Drawer>
        {BOTTOM_NAVIGATOR_MENU.map(({ label, Icon, to }, idx) => (
          <BottomNavigationAction
            key={`${label}-${idx}`}
            component={Link}
            to={to}
            label={label}
            icon={Icon}
            style={{ color: active === idx + 1 ? ACTIVE : INACTIVE }}
            onClick={onClick(idx + 1)}
          />
        ))}
        <BottomNavigationAction
          label="Menu"
          icon={isMenuOpen === false ? <MenuIcon /> : <Close />}
          onClick={onMenuClick}
          style={{ color: INACTIVE }}
        />
      </BottomNavigation>
    </Hidden>
  );
};

export default BottomNavigator;
